import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import merge from 'lodash/merge';
import tap from 'redux-tap';
import { ANALYTICS_DONE_PAGE_VIEW, ANALYTICS_SEND_PAGE_VIEW } from '../../actions/Analytics';
import { EmceeVariant } from '../../constants/EmceeVariants';
import { selectLaunchDarklyUserKey } from '../../reducers/Configuration';
import { getExtensionIDFromURL } from '../../services/AP';
import { isEmceeConnect } from '../../utils/package-connect-utils';
import { getAnalyticsRouteParams, getAnalyticsSourceParam, getPageAttributes } from '../commonUtils';
import { sendPageViewEvent } from '../Send';
const isPageView = action => action.type === ANALYTICS_SEND_PAGE_VIEW;
const sendPageView = (_, __, store) => {
  const state = store.getState();
  const currentScreen = state.analytics.modalStack.last() || state.analytics.currentScreen;
  const lastScreenEvent = state.analytics.lastScreenEvent;
  const analyticsAttributes = state.analytics.attributes;
  if (currentScreen && lastScreenEvent !== currentScreen) {
    const source = getAnalyticsSourceParam();
    const emceeVariant = isEmceeConnect() ? EmceeVariant.Connect : EmceeVariant.Native;
    const featureFlags = state.configuration.featureFlags.fold(() => {
      /* feature flags don't exist */
    }, featureFlagsRes => featureFlagsRes.fold(() => {
      /* fetching feature flags had errors */
    }, ff => ff.getAllFlags().toJS()));
    const launchDarklyUserKey = selectLaunchDarklyUserKey(state.configuration);
    getExtensionIDFromURL(extensionID => {
      var _window, _document;
      const pageAttributes = getPageAttributes((_window = window) === null || _window === void 0 ? void 0 : _window.location.href, (_document = document) === null || _document === void 0 ? void 0 : _document.referrer);
      sendPageViewEvent(merge(currentScreen, {
        attributes: _objectSpread(_objectSpread({}, getAnalyticsRouteParams(analyticsAttributes)), {}, {
          featureFlags,
          launchDarklyUserKey,
          source,
          extensionID,
          emceeVariant
        }, pageAttributes)
      }));
      store.dispatch({
        type: ANALYTICS_DONE_PAGE_VIEW,
        source: currentScreen
      });
    });
  }
};
const screenViewMiddleware = tap(isPageView, sendPageView);
export default screenViewMiddleware;